import { animate, style, transition, trigger } from '@angular/animations';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { ApiService } from '@quorum/api';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { ServiceAppointmentBaseComponent } from '../service-appointment.base.component';
@Component({
  selector: 'sha-service-appointment-form',
  templateUrl: './service-appointment-form.component.html',
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('500ms', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('500ms', style({ opacity: 0 }))]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./service-appointment-form.component.scss'],
})
export class ServiceAppointmentFormComponent
  extends ServiceAppointmentBaseComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  constructor(
    public systemControlStateService: SystemControlStateService,
    public authenticationStateService: AuthenticationStateService,
    public apiService: ApiService,
    public cdr: ChangeDetectorRef
  ) {
    super(systemControlStateService, authenticationStateService, apiService, cdr);
  }
  ngOnChanges(changes: SimpleChanges) {}

  ngOnInit() {
    this.Init();
  }

  ngOnDestroy() {
    this.techOrTechGroupSub.unsubscribe();
    this.odometerInSub.unsubscribe();
    this.sameAsPickupSub.unsubscribe();
    this.appointmentFormSub.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.appointmentForm) {
        this.appointmentFormEmit.emit(this.appointmentForm);
      }
    });
  }

  validateNumber(event: any) {
    const keyCode = event.keyCode;

    const excludedKeys = [8];

    if (!((keyCode >= 48 && keyCode <= 57) || excludedKeys.includes(keyCode))) {
      event.preventDefault();
    }
  }
}
